<template>
  <div class="card" :title="card.description" @click="click()">
    <div class="selected" v-if="isSelected"></div>
    <span class="title">{{ card.title }}</span>

    <CardFields :card="card" />

    <div class="footer">
      <font-awesome-icon v-if="card.description" class="description-icon" icon="align-left" />
      <div class="card-info" v-if="card.messages.length">
        <font-awesome-icon :icon="['far', 'comment']" />
        <span>{{ card.messages.length }}</span>
      </div>
      <div class="card-info" v-if="card.files.length">
        <font-awesome-icon icon="paperclip" />
        <span>{{ card.files.length }}</span>
      </div>
      <span class="timestamp" v-if="createdDate">{{ createdDate }}</span>
      <span class="id clickable" @click.stop="copyUrlToClipboard(card)">{{ card.in_board_id }}</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import urlManager from "@/common/urls.js";
import SimpleClipboard from "@/common/simpleClipboard";

import CardFields from "./CardFields.vue";

export default {
  name: "Card",
  components: { CardFields },
  props: { card: { required: true }, isSelected: { type: Boolean } },
  computed: {
    ...mapGetters(["isMobileDevice"]),
    createdDate() {
      if (!this.card) return "";
      return this.card.moment.format("DD.MM.YY HH:mm:ss");
    },
    show() {
      if (!this.isSelected) return true;
      return !this.drag.card;
    }
  },
  methods: {
    copyUrlToClipboard() {
      if (!this.card) return;

      new SimpleClipboard().copyText(urlManager.getCardUrl(this.card));
      this.$snotify.success(`Ссылка на карточку ${this.card.in_board_id} скопирована`, {
        timeout: 1000,
        showProgressBar: false
      });
    },
    click() {
      this.$emit("click", this.card);
    }
  }
};
</script>
<style lang="postcss">
.board-list {
  .card {
    position: relative;

    .selected {
      position: absolute;
      left: 0;
      top: 0;
      background: var(--bg-card-selected);
      width: 5px;
      height: 100%;
      border-radius: 5px;
    }

    .footer {
      height: 16px;
    }

    .id {
      float: right;
      font-weight: bold;
      color: var(--color-card-id);
      padding: 0 0.5em;
    }

    .timestamp {
      display: inline-block;
      font-size: 10px;
      color: #888;
      padding: 0px;
      text-overflow: ellipsis;
      user-select: none;
      font-weight: bold;
      float: right;
      vertical-align: middle;
      line-height: 16px;
    }

    .description-icon {
      margin-right: 0.5em;
    }

    .card-info {
      display: inline-block;
    }

    .card-info > span {
      margin-left: 0.2em;
    }

    @media only screen and (min-width: 800px) {
      .card:hover {
        opacity: 0.5;
      }
    }
  }
}
</style>
